import { URLS } from '../../constants';
import apiClient from '../client';
const getAllTarget = {
    getTarget: ({
        programId,
        hasCriteria = false,
        isTargetPinned,
        quickLookId,
        phase,
    }: {
        programId: any;
        hasCriteria?: boolean;
        isTargetPinned: any;
        quickLookId: any;
        phase?: any;
    }) =>
        apiClient.post(URLS.getAllTarget, {
            data: {
                programId,
                hasCriteria,
                isTargetPinned,
                quickLookId,
                phase,
            },
        }),
};
export default getAllTarget;
